import {AppBar, Stack, Toolbar, Typography} from "@mui/material";
import logo from "../assets/images/irriwatch-logo.svg";

export const EmptyHeader: React.FC = () => (
    <AppBar color="dark" position="static" elevation={0} sx={{height: "3.5rem"}}>
        <Toolbar
            disableGutters
            variant="dense"
            sx={{
                minHeight: "3.5rem",
                height: "3.5rem",
            }}
        >
            <Stack
                direction="row"
                alignItems="start"
                sx={{
                    width: "17.75rem",
                    minWidth: "17.75rem",
                    paddingX: "1.125rem",
                    paddingY: "0.5rem",
                    height: "2.5rem",
                }}
            >
                <img src={logo} width="104px" />
                <Stack direction="row" alignItems="end" sx={{height: "100%"}}>
                    <Typography fontSize={12} lineHeight="0.75em">
                        powered by Hydrosat
                    </Typography>
                </Stack>
            </Stack>
        </Toolbar>
    </AppBar>
);
